import _extends from "@babel/runtime/helpers/extends";
import { CustomItem, NavigationContent, Section, SideNavigation } from '@atlaskit/side-navigation';
import { Link } from '@atlassian/amkt-common';
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { usePartnerPermissions, useQueryParams } from '@atlassian/mpac-ui';
import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { dataApiItemAnalyticsConfig, sideNavAnalyticsConfig } from '../../PartnerReports.events';
import { getReportsNameFilterWithoutComponent } from '../filtersToBeShownByReport';
import { getNewReportPathname, getNewSearch } from '../ReportFilters.utils';
// eslint-disable-next-line max-lines-per-function
export default function SideNavReportsFilters(props) {
  var _permissions$canViewS, _permissions$canViewU;
  const {
    partnerId,
    reportName
  } = props;
  const queryParams = useQueryParams();
  const fireAnalyticsEvent = useAnalyticsEvents();
  const permissions = usePartnerPermissions();
  const canViewSalesReport = (_permissions$canViewS = permissions === null || permissions === void 0 ? void 0 : permissions.canViewSalesReport) !== null && _permissions$canViewS !== void 0 ? _permissions$canViewS : false;
  const canViewUsageReports = (_permissions$canViewU = permissions === null || permissions === void 0 ? void 0 : permissions.canViewUsageReports) !== null && _permissions$canViewU !== void 0 ? _permissions$canViewU : false;
  const sideNavMenuItems = getReportsNameFilterWithoutComponent(reportName, canViewSalesReport, canViewUsageReports);

  // get the default report route on clicking side nav tabs
  const getReportRoute = item => {
    if (item.type === 'data-api') {
      return 'http://go.atlassian.com/marketplace-api';
    } else {
      return "".concat(getNewReportPathname(partnerId, item.value)).concat(getSearch(item));
    }
  };

  // Show divider to separate different report type group based on trends, explore and data-api
  const shouldShowSeparator = (item, index) => index > 0 && index < sideNavMenuItems.data.length && item.type !== sideNavMenuItems.data[index - 1].type;
  const getSearch = item => {
    if (item.type === 'trends') {
      return getNewSearch({}, 'period', 'past90Days');
    } else if (item.type === 'explores') {
      if (queryParams.text) {
        return getNewSearch({}, 'text', '');
      }
      return '';
    }
  };
  const fireEvent = item => {
    if (reportName !== item.value) {
      setTimeout(() => {
        fireAnalyticsEvent(item.value === '' ? dataApiItemAnalyticsConfig({
          partnerId,
          reportName: item.value,
          label: item.label
        }) : sideNavAnalyticsConfig({
          partnerId,
          reportName: item.value,
          label: item.label
        }));
      }, 0);
    }
  };
  const getExternalLinkProps = item => {
    return {
      component: Link,
      href: getReportRoute(item),
      target: '_blank'
    };
  };
  const getRouteLinkProps = item => {
    return {
      component: RouteLink,
      to: getReportRoute(item)
    };
  };
  const getCommonCustomItemProps = item => {
    return {
      isSelected: item.value === reportName,
      onClick: () => fireEvent(item),
      iconAfter: item.icon && /*#__PURE__*/React.createElement(item.icon, null)
    };
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SideNavigation, {
    label: "project"
  }, /*#__PURE__*/React.createElement(NavigationContent, null, sideNavMenuItems.data.map((item, index) => /*#__PURE__*/React.createElement(Section, {
    key: item.label,
    hasSeparator: shouldShowSeparator(item, index)
  }, item.isExternalLink ? /*#__PURE__*/React.createElement(CustomItem, _extends({}, getExternalLinkProps(item), getCommonCustomItemProps(item)), item.label) : /*#__PURE__*/React.createElement(CustomItem, _extends({}, getRouteLinkProps(item), getCommonCustomItemProps(item)), item.label))))));
}